__turbopack_context__.v({
  "container": "HelpDialog-module-scss-module__ddOSrW__container",
  "dialog": "HelpDialog-module-scss-module__ddOSrW__dialog",
  "footer": "HelpDialog-module-scss-module__ddOSrW__footer",
});
